import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class PaymentAPI {

    constructor(http) {
        this.http = http;
    }

    getPublicApiKey(token, successCallback, errorCallback, wl_id) {
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader("Authorization", token);

        });

        let queryString = '';

        if(wl_id) {
            queryString += `?wl_id=${wl_id}`;
        }

        this.http.get('api/payment/getPublicApiKey'+queryString)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("key"))
                        successCallback(json.key);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getSubscriptionFee(token, successCallback, errorCallback) {
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader("Authorization", token);

        });

        this.http.get('api/payment/getSubscriptionFee')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);
                    else {
                        successCallback(json);
                    }

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }


    getRequestPackageList(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader("Authorization", token);

        });


        this.http.get('api/payment/getRequestPackageList')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("requestPackageList"))
                        successCallback(json.requestPackageList);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getPaymentData(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
                .withHeader("Authorization", token);

        });


        this.http.get('api/payment/getPaymentData')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("last4"))
                        successCallback(json.last4);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }



    processPackagePurchase(data, token, successCallback, errorCallback) {


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/payment/processPackagePurchase', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("account"))
                        successCallback(json.account);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    processSubscriptionPayment(data, token, successCallback, errorCallback) {


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/payment/processSubscriptionPayment', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("account")){
                        let message= null;

                        if (json.cardUpdated) message="Card information is updated!";
                        else if (json.plusYearly) message="Successfully switched to a PLUS Annually subscription!";
                        else if (json.plusMonthly) message="Successfully switched to a PLUS Monthly subscription!";
                        successCallback(json.account,message);

                    }
                    
                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }   
            });

    }
upgradePlus(data, token, successCallback, errorCallback) {


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/payment/upgradePlus', data)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("account"))
                        successCallback(json.account);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    convertToPayPerVideo(token, successCallback, errorCallback) {


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/payment/convertToPayPerVideo')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("account"))
                        successCallback(json.account);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    validateCoupon(data, token, successCallback, errorCallback) {


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.get('api/payment/validateCoupon/' + encodeURIComponent(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("coupon"))
                        successCallback(json.coupon);

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

}